import ChatContext from "@/shared/models/ChatContext";
import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import {
  EventName,
  EventParameter,
  sendEvent,
} from "../../../shared/utils/UsageAnalytics";

export const useEstimatePlaybookChat = () => {
  const {
    data: cost,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<number>((response) => parseFloat(response));
  const estimate = async (playbookId: string, context: ChatContext) => {
    const data = context.extractChatCreateData();

    const formatData = new FormData();
    formatData.append("PlaybookId", playbookId);
    data.companyIds.forEach((id) =>
      formatData.append("CompanyIds", id.toString()),
    );
    data.filingIds.forEach((id) => formatData.append("FilingIds", id));
    data.transcriptIds.forEach((id) => formatData.append("TranscriptIds", id));
    data.userDocumentIds.forEach((id) => formatData.append("ContentIds", id));
    formatData.append("UseInternet", data.includeWeb.toString());

    await call("/playbook/estimate", "POST", {}, formatData);

    sendEvent(EventName.PlaybookEstimate, {
      [EventParameter.PlaybookId]: playbookId,
    });
  };

  return { cost, estimate, isLoading, isFailed };
};
